import YFormQrCode from './QrCode';

export { YFormQrCode };
export default YFormQrCode;
